export const areRoomIdsTheSame = (currentIds, oldIds) =>
  currentIds.length === oldIds.length &&
  currentIds.every((value, index) => value === oldIds[index]);

export default {
  areRoomIdsTheSame
};
